import { render, staticRenderFns } from "./plan-legende.vue?vue&type=template&id=3fd19e98&"
import script from "./plan-legende.vue?vue&type=script&lang=js&"
export * from "./plan-legende.vue?vue&type=script&lang=js&"
import style0 from "./plan-legende.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports